import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { TextField } from "@mui/material";
import useModal from "../../hooks/useModal";
import { toast } from "react-toastify";
import Button from "../ui/Button";
import useLoader from "../../hooks/useLoader";
import { withdrawResignation } from "../../services/exitManagement";

// Define schema
const remarksSchema = z.object({
  remarks: z.string().min(1, "Remarks are required"),
});
const WithdrawResignation = ({ resignationId, action, fetchResignations }) => {
  const { hideModal } = useModal();
  const { showLoader, hideLoader } = useLoader();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(remarksSchema),
    defaultValues: {
      remarks: "",
    },
  });

  const handleWithdraw = async (data, id, action) => {
    showLoader();
    try {
      const response = await withdrawResignation(id, data.remarks, action);

      if (response.status === 200) {
        toast.success(
          response.data.message || "Resignation withdrawn successfully"
        );
        fetchResignations(1);
        reset();
        hideModal();
      } else {
        const errorMessage =
          response.data?.error ||
          response.data?.message ||
          "Failed to withdraw resignation";
        toast.error(errorMessage);
        console.error("Error withdrawing resignation:", errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "An unexpected error occurred while withdrawing resignation";
      toast.error(errorMessage);
      console.error("Error withdrawing resignation:", errorMessage);
    } finally {
      hideLoader();
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data) =>
        handleWithdraw(data, resignationId, action)
      )}
      className="pt-2"
    >
      <div className="row mb-3">
        <div className="col-md-12">
          <Controller
            name="remarks"
            control={control}
            render={({ field }) => (
              <TextField
                label="Remarks*"
                variant="standard"
                {...field}
                multiline
                rows={3}
                error={!!errors.remarks}
                helperText={errors.remarks?.message}
                fullWidth
                disabled={isSubmitting}
              />
            )}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end gap-1">
        <Button
          variant="success"
          size="small"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
        <Button
          variant="light"
          size="small"
          onClick={hideModal}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
};
export default WithdrawResignation;
